import Cart from "../views/checkout/Cart"
import Checkout from "../views/checkout/Checkout"
import PickupComplete from "../views/checkout/PickupComplete"
import {productsExists} from "./helper"

export default [
    {
        path: '/cart',
        name: 'Cart',
        beforeEnter: productsExists,
        component: Cart
    },
    {
        path: '/checkout',
        name: 'Checkout',
        beforeEnter: productsExists,
        component: Checkout
    },
    {
        path: '/pickupComplete',
        name: 'PickupComplete',
        component: PickupComplete
    }
]
